import { useState } from 'react';

import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Box,
  Divider,
  Text,
  VStack,
  RadioGroup,
  Radio,
  HStack,
} from '@chakra-ui/react';

import { BLACK } from '@constants/colors';

import { SORTS } from '@constants/sorts';
import CustomButton from '@components/Button';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  handleSort: (sort: string) => void;
};

const Sort = ({ isOpen, onClose, handleSort }: Props) => {
  const [sortBy, setSortBy] = useState('latest');

  const handleSortClick = () => {
    handleSort(sortBy);
    onClose();
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton
          variant="ghost"
          _hover={{ bg: 'transparent' }}
          _focus={{ boxShadow: 'none' }}
          color={BLACK}
          top="15px"
          as="b"
        />
        <DrawerHeader>URUTKAN</DrawerHeader>
        <DrawerBody>
          <VStack align="start">
            <Text paddingBottom="10px">Urutkan berdasarkan...</Text>
            <Divider />
            <RadioGroup
              value={sortBy}
              onChange={setSortBy}
              defaultValue="latest"
              paddingTop="5px"
            >
              <VStack align="start">
                {SORTS.map((sort, i) => (
                  <>
                    <Radio
                      key={i}
                      value={sort.value}
                      colorScheme="red"
                      _focus={{ boxShadow: 'none' }}
                    >
                      {sort.name}
                    </Radio>
                    <Divider paddingTop="5px" paddingBottom="5px" />
                  </>
                ))}
              </VStack>
            </RadioGroup>
          </VStack>
        </DrawerBody>
        <DrawerFooter>
          <HStack>
            <CustomButton
              text="BATAL"
              variant="white"
              icon="none"
              w="100px"
              onClick={() => onClose()}
            />
            <CustomButton
              text="URUTKAN"
              variant="red"
              icon="none"
              w="120px"
              onClick={() => handleSortClick()}
            />
          </HStack>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default Sort;
